export default "https://assets-v2.scaler.com/packs/files/b_img_1.dc749f.webp";